import { render, staticRenderFns } from "./SchematicDetails.vue?vue&type=template&id=9aff8c32&scoped=true"
import script from "./SchematicDetails.vue?vue&type=script&lang=js"
export * from "./SchematicDetails.vue?vue&type=script&lang=js"
import style0 from "./SchematicDetails.vue?vue&type=style&index=0&id=9aff8c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aff8c32",
  null
  
)

export default component.exports